export default __webpack_public_path__ + "static/illo-businesses-c6f419f605b5700995ee7da0f44ed325.svg";